import cn from 'classnames';
import { BreedSegmentationIds } from 'constants/segmentation';
import AnimateDropdown from 'modules/landingpage/components/need-capture/components/content/components/animate-dropdown';
import { FormattedMessage } from 'react-intl';

interface Props {
  isOpen: boolean;
  selectedOption?: BreedSegmentationIds;
  onSelect: (value: BreedSegmentationIds) => void;
}

/**
 * It renders a list of age. It's used in the need capture component.
 */
const BreedSelectorDesktop: React.FC<Props> = ({
  isOpen,
  selectedOption,
  onSelect,
}) => (
  <AnimateDropdown isOpen={isOpen}>
    {Object.entries(BreedSegmentationIds).map(([key, value]) => (
      <button
        key={key}
        className={cn(
          'w-full px-4 py-2 text-left',
          selectedOption === value
            ? 'bg-grey-100 hover:bg-grey-100'
            : 'hover:bg-grey-50'
        )}
        onClick={() => onSelect(value)}
      >
        <FormattedMessage id={`common:pet-profile:breed-selector:${value}`} />
      </button>
    ))}
  </AnimateDropdown>
);

export default BreedSelectorDesktop;
